import React from 'react';
// import MainPic from '../assets/img/mainPic.jpg';
// import MainVideo from '../assets/img/sapimilkindo-main-video.mp4'

class Jumbotron extends React.Component {
	// static propTypes = {
	// 	name: React.PropTypes.string,
	// };

	// constructor(props) {
	// 	super(props);
	// }

	render() {
		return (
			<div className="container jumbotron">
			
				<iframe src="https://www.youtube.com/embed/Tq-dM6u1aVw?autoplay=1&loop=1&playlist=Tq-dM6u1aVw" title="Video Profile Sapimilkindo" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>

			</div>
		);
	}
}
export default Jumbotron;
				

				// <img className="main-pic" src={MainPic} alt="Jumbotron"/>